import React, { useState } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter,
} from "reactstrap";


import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import { generateFinalCSV } from "../../../../context/actions/document";
import moment from 'moment';
toast.configure();

const FinalCsvModal = ({ closeModal, showModel, lodder }) => {

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const dispatch = useDispatch()
  const [disable, setDisable] = useState(false)
  const [title, setTitle] = useState('Download')
  const [error, setError] = useState('')
  const [height, setHeight] = useState('0')
  //convert response from api to a file then download
  const downloadCSV = async (res) => {

    const data = Buffer.from(res?.finalDocSheetBuffer);
    let outputFilename = "Report from " + moment(startDate).format('MM-DD-YYYY') + " To " + moment(endDate).format('MM-DD-YYYY') + ".xlsx"; 
    const url = URL.createObjectURL(new Blob([data], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  
  };

  const download = () => {
    console.log('startDate====',startDate);
    setDisable(true)
    if (title === "Download Anyway") {
      setError('')
      dispatch(generateFinalCSV({ startDate: startDate, endDate: endDate, notValidated: true}, async (response) => {
        if (response && !response.errors) {
          setDisable(false)
          setTitle("Download")
          downloadCSV(response)
        }
        else {
          toast.warn(response.errors.msg)
          setDisable(false)
          setTitle("Download")
        }
      })
      );
    }
    else {
      dispatch(generateFinalCSV({ startDate: startDate, endDate: endDate }, async (response) => {
        if (response && !response.errors) {
          setDisable(false)
          downloadCSV(response)
        }
        else if (response.messageID) {
          setDisable(false)
        }
        else {
          setError(response.errors.msg)
          setTitle("Download Anyway")
          setDisable(false)
        }
      })
      );
    }
  };

  const close = () => {
    closeModal()
    setTitle("Download")
    setDisable(false)
    setError('')
    setHeight('0')
    setStartDate(new Date()) //sets date to default by today's date
    setEndDate(new Date())   //sets date to default by today's date
  };
  return (
    <>
      <Modal isOpen={showModel}
        backdrop="static">
        <ModalHeader>
          Select a date range to download Final document CSV
        </ModalHeader>
        <ModalBody style={{ minHeight: height }}>
          <div className="row">
            <div className="col-6">
              Start Date
              <DatePicker
                selected={startDate}
                onChange={(e) => { console.log(e);setStartDate(new Date(e)); setHeight('0'); }}
                onFocus={() => { setHeight('300px') }}
                onBlur={() => { setHeight('0') }}
                maxDate={new Date()}
                className="date-range form-control"
                placeholderText="Start Date"
              />
            </div>
            <div className="col-6">
              End Date
              <DatePicker
                selected={endDate}
                onChange={(e) => { setEndDate(new Date(e)); setHeight('0') }}
                onFocus={() => { setHeight('300px') }}
                onBlur={() => { setHeight('0') }}
                maxDate={new Date()}
                minDate={startDate}
                className="date-range form-control"
                placeholderText="End Date"
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <p style={{ color: "red" }}>{error}</p>
          <Button color="link" onClick={download} disabled={disable} className="cancel-btn">
            {title}
          </Button>
          <Button
            color="secondary"
            onClick={close}
          >
            Close
          </Button>
        </ModalFooter>

      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default FinalCsvModal;
